const DEFAULT_DURATION_TYPE = "MONTHS";
const DEFAULT_DURATION_VALUE = null;

export { DEFAULT_DURATION_TYPE, DEFAULT_DURATION_VALUE };
